import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ApplicationListItem extends Component {
    static propTypes = {
        item: PropTypes.any
    };

    renderMerchantName(merchantName) {
        return merchantName ? merchantName : 'No Merchant Name';
    }

    renderStatus(status) {
        return status ? status : 'No Status';
    }

    render() {
        const application = this.props.item;

        return (
            <div className="list-item">
                <div className="list-item-left">
                    <span className="application-merchantName">
                        {this.renderMerchantName(application.legalName)}
                    </span>
                </div>
                <div className="list-item-right">
                    <span className="application-status">
                        {this.renderStatus(application.status)}
                    </span>
                </div>
            </div>
        );
    }
}
